import { Directive } from '@angular/core';
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from '@angular/forms';

@Directive({
  selector: '[appPincodeValidation]'
})
export class PincodeValidationDirective {

  constructor() { }

}

export function pincodeValidator(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value) {
      let value: string = control.value;
      let specialChar = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      if (!specialChar.test(value)) {
        if (value.length >= 6) {
          let numberRegex = new RegExp('^[0-9]*$');
          if (!numberRegex.test(value.substr(0, 6))) {
            return { 'pattern': { value: control.value } }
          }         
                    }
                    else {
                      return { 'pattern': { value: control.value } }

                      // return null;
                    }
                  }     
                  else {
                    return { 'pattern': { value: control.value } }
                  }       
                }
  };
}
